{"schemaVersion":1,"release":{"version":"1.1.4","build":166,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.4-166.dmg","sha256":"d09a3b7b0f4b08ff4e418bd77ff7b612f645433cc28d348d45187a85c7c72f6c","size":29291384}}
